import ChatBox from "./ChatBox"
const AiChatBox = () => {
    return (
         <ChatBox/>
    )
}
export default AiChatBox